import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID,  } from "..";
import { Spinner } from "react-bootstrap";
import PurchaseOrderListLayer from "../components/PurchaseOrderListLayer";

const PurchaseOrderListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
   const locationId = localStorage.getItem('locationID')

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/purchase-orders?locationId=${locationId}`);
      const result = await response.json();
      setData(result.data.reverse());
    } catch (err) {
      console.error("Error fetching purchase orders:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <MasterLayout>
      <Breadcrumb title="Purchase Orders - List" />
      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}
      {/* {!loading && data?.length === 0 && (
        <div className="text-center mt-4">
          <p>No Purchase Order data found....</p>
        </div>
      )} */}
      {!loading  && <PurchaseOrderListLayer ordersData={data} />}
    </MasterLayout>
  );
};

export default PurchaseOrderListPage;
